import { ArtistExclusionForm } from "@components/artist_exclusion_form/artist_exclusion_form";
import { Icon } from "@components/icon";
import React, { type FC } from "react";

const ArtistExclusionCreatePage: FC = () => {
  return (
    <div className="content">
      <header>
        <h1>Create Artist Exclusion</h1>
        <div className="controls">
          <a
            href="/admin/exclusions"
            className="js-toggle-form add_new"
            title="Back to index"
          >
            <Icon name="arrow_back_ios" />
          </a>
        </div>
      </header>

      <p>
        How to: If you enter an exclusion here with &quot;roger&quot;, &quot;Mr
        Rogers&quot; and &quot;Roger Moore&quot; artists would both be excluded.
        Make the pattern as long as needed to uniquely identify the artist.
      </p>
      <ArtistExclusionForm />
    </div>
  );
};

export { ArtistExclusionCreatePage };
